module.exports = __webpack_public_path__ + "img/77350.43770b6c.svg";